import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ComingSoonPage from './pages/ComingSoonPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoonPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;